import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';
import CadastroFormDrawer from '../Components/CadastroFormDrawer/CadastroFormDrawer';
import './sistemas.css';
import ListaSistemas from '../Components/ListarSistemas/listaSistemas';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../config/backend';
import verificandoApp from '../../FuncoesGerais/verificaApp';

function Sistemas() {
    const history = useHistory();
    const location = useLocation();
    const editIdFromState = location.state?.editId;

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");
        if (!resultado) history.push("/");
    };

    const [data, setData] = useState([]);
    const [descr, setDescr] = useState('');
    const [formDrawerOpen, setFormDrawerOpen] = useState(false);
    const [codSis, setCodSis] = useState('');
    const [nomSis, setNomSis] = useState('');
    const [desSis, setDesSis] = useState('');
    const [setSis, setSetSis] = useState('');
    const [sitSis, setSitSis] = useState('');
    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');

    const buscandoSistema = async (id) => {
        if (!id) return;
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas/espec", {
                headers: { Authorization: `${token}` },
                params: { codSis: id }
            });
            if (response.data.length > 0) {
                const r = response.data[0];
                setUpdIns('U');
                setCodSis(r.codsis ?? r.CODSIS ?? '');
                setNomSis((r.nomsis ?? r.NOMSIS ?? '').toString());
                setDesSis((r.dessis ?? r.DESSIS ?? '').toString());
                setSetSis((r.setsis ?? r.SETSIS ?? r.SCTSTS ?? '').toString());
                setSitSis((r.sitsis ?? r.SITSIS ?? r.SLISIS ?? '').toString());
            } else {
                setUpdIns('I');
                setCodSis(''); setNomSis(''); setDesSis(''); setSetSis(''); setSitSis('');
            }
        } catch (e) { console.error(e); }
    };

    const limparForm = () => {
        setUpdIns('I');
        setCodSis(''); setNomSis(''); setDesSis(''); setSetSis(''); setSitSis('');
        setMensagem('');
    };

    const inserindoSistema = async () => {
        if (!nomSis.trim()) { setMensagem("Nome obrigatório!"); return; }
        if (!desSis.trim()) { setMensagem("Descrição obrigatória!"); return; }
        if (!setSis.trim()) { setMensagem("Setor obrigatório!"); return; }
        if (!sitSis) { setMensagem("Situação obrigatória!"); return; }
        setMensagem('');
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas", { nomSis, desSis, setSis, sitSis }, { headers: { Authorization: `${token}` } });
            } else {
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas", { codSis, nomSis, desSis, setSis, sitSis }, { headers: { Authorization: `${token}` } });
            }
            limparForm();
            setFormDrawerOpen(false);
            fetchData();
        } catch (e) { setMensagem('Erro ao salvar'); }
    };

    const fetchData = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas", {
                headers: { Authorization: `${token}` },
                params: { descr: descr || ' ' }
            });
            const raw = response.data || [];
            const normalized = raw.map((s) => ({
                codsis: s.codsis ?? s.CODSIS,
                nomsis: s.nomsis ?? s.NOMSIS ?? '',
                dessis: s.dessis ?? s.DESSIS ?? '',
                setsis: s.setsis ?? s.SETSIS ?? s.SCTSTS ?? '',
                sitsis: (s.sitsis ?? s.SITSIS ?? s.SLISIS ?? '').toString()
            }));
            setData(normalized);
        } catch (e) { console.error(e); setData([]); }
    };

    useEffect(() => { verificar(); fetchData(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => { if (editIdFromState) { buscandoSistema(editIdFromState).then(() => setFormDrawerOpen(true)); } }, [editIdFromState]);

    const handleEdit = (id) => { buscandoSistema(id).then(() => setFormDrawerOpen(true)); };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado">
                    <div className="page-header">
                        <h1>Sistemas</h1>
                        <div className="toolbar flex-wrap">
                            <div className="input-group input-group-sm" style={{ maxWidth: 280 }}>
                                <input value={descr} onChange={(e) => setDescr(e.target.value)} type="text" className="form-control" placeholder="Pesquisar" />
                                <button onClick={fetchData} className="btn btn-secondary" type="button"><i className="fas fa-search" /></button>
                            </div>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => { limparForm(); setFormDrawerOpen(true); }}>
                                Novo sistema
                            </button>
                        </div>
                    </div>
                    <CadastroFormDrawer
                        open={formDrawerOpen}
                        onClose={() => { limparForm(); setFormDrawerOpen(false); }}
                        title={updIns === 'U' ? 'Editar sistema' : 'Novo sistema'}
                    >
                        <div className="cadastro-form-drawer-form">
                            <div className="form-group">
                                <label>Sequência (edição)</label>
                                <input type="text" onChange={(e) => buscandoSistema(e.target.value)} className="form-control form-control-sm" placeholder="Código para editar" />
                            </div>
                            <div className="form-group">
                                <label>Nome</label>
                                <input value={nomSis} onChange={(e) => setNomSis(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Descrição</label>
                                <input value={desSis} onChange={(e) => setDesSis(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Setor responsável</label>
                                <input value={setSis} onChange={(e) => setSetSis(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Situação</label>
                                <select value={sitSis} onChange={(e) => setSitSis(e.target.value)} className="form-control form-control-sm">
                                    <option value="">Escolher...</option>
                                    <option value="A">Ativo</option>
                                    <option value="I">Inativo</option>
                                </select>
                            </div>
                            {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                            <div className="cadastro-form-drawer-form__actions">
                                <button onClick={() => { limparForm(); setFormDrawerOpen(false); }} type="button" className="btn btn-secondary btn-sm">Cancelar</button>
                                <button onClick={inserindoSistema} type="button" className="btn btn-primary btn-sm">Salvar</button>
                            </div>
                        </div>
                    </CadastroFormDrawer>
                    <ListaSistemas arraySistemas={data} onEdit={handleEdit} />
                </div>
            </main>
        </div>
    );
}

export default Sistemas;
